// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Zachary Thomas
//
// Last Modified: 2025-11-14
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Attempt to load initial state from local storage.
// We need to support both legacy and new ID tokens, since the legacy mobile app uses a different name for storage.
let initialToken = null;
const newLocalStorageToken = localStorage.getItem("reduxIdToken");
const legacyLocalStorageToken = localStorage.getItem("reduxAuthorizerToken");
const newLocalStorageTokenIsSet = newLocalStorageToken !== "" && newLocalStorageToken !== null;
const legacyLocalStorageTokenIsSet = legacyLocalStorageToken !== "" && legacyLocalStorageToken !== null;
if (!newLocalStorageTokenIsSet && legacyLocalStorageTokenIsSet) {
  initialToken = legacyLocalStorageToken;
} else if (newLocalStorageTokenIsSet) {
  initialToken = newLocalStorageToken;
}

const initialState: string | null = initialToken;

// A Redux slice for the ID token that is passed to the backend.
const idTokenSlice = createSlice({
  name: "idToken",
  initialState,
  reducers: {
    setIdToken: (state, action: PayloadAction<string | null>) => {
      localStorage.setItem("reduxIdToken", action.payload ?? "");
      return action.payload;
    },
  },
});

export const { setIdToken } = idTokenSlice.actions;
export default idTokenSlice.reducer;
